import styled from '@emotion/styled';
import * as React from 'react';
import { theme } from '../../theme';
import { Icon } from '../icon';
import { getStyles } from './styles';
import { Spinner } from '../spinner';
const StyledSpan = styled.span `
	width: 100%;
	display: inherit;
	justify-content: inherit;
	align-items: inherit;
	height: 24px; // Should match icon svg height
`;
const StyledIcon = styled(Icon) `
	visibility: ${(props) => (props.isHidden ? 'hidden' : 'visible')};
`;
const StyledText = styled.span `
	visibility: ${(props) => (props.isHidden ? 'hidden' : 'visible')};
	padding: 0 0.5rem;
`;
export const StyledButton = styled.button `
	display: flex;
	position: relative;
	justify-content: center;
	align-items: center;
	flex-direction: row;

	cursor: pointer;

	${theme.typography.IR100}
	line-height: ${theme.typography.lineHeight.sm};

	border: none;
	border-radius: ${theme.radii.radii30};

	:disabled {
		opacity: 20%;
		cursor: not-allowed;
	}

	// TODO: This may need to be more specific or tokenized
	transition: background-color 120ms ease-in-out;

	${({ variant, fill, size }) => getStyles(variant, fill, size)};

	// Properties in :active needs to be declared after invoking the function getStyles
	// in order not to be overriden.
	outline-offset: -2px;
	:active {
		outline: 0;
	}

	${({ fullWidth }) => (fullWidth ? { width: '100%' } : { width: 'auto' })};
`;
export const StyledSpinnerForButton = styled(Spinner) `
	visibility: ${(props) => (props.isSubmitting ? 'visible' : 'hidden')};
	position: absolute;
`;
export const Button = (props) => {
    var _a;
    const { fill = 'solid', variant = 'primary', size = 'regular', text, icon, isSubmitting, } = props;
    return (React.createElement(StyledButton, Object.assign({ fill: fill, variant: variant, size: size, type: (_a = props.type) !== null && _a !== void 0 ? _a : 'button' }, props),
        React.createElement(StyledSpan, null,
            icon && (React.createElement(StyledIcon, { name: icon, color: "inherit", isHidden: isSubmitting })),
            text && (React.createElement(StyledText, { isHidden: isSubmitting }, text)),
            React.createElement(StyledSpinnerForButton, { isSubmitting: isSubmitting }))));
};
//# sourceMappingURL=Button.js.map